<template>
  <div aria-live="assertive" class="alertsCorner pointer-events-none fixed inset-0 top-0 sm:top-12 px-4 py-3 sm:p-6 flex flex-col items-end justify-start transition-all">
    <section class="flex w-full sm:max-w-lg flex-col items-center sm:items-end relative">
      <!-- CLOSE ALL ALERTS BUTTON -->
      <button
        v-if="displayedNewAlerts.length > 1"
        @click="closeAllAlerts"
        class="absolute top-0 right-0 fadein flex items-center fadein pointer-events-auto cursor-pointer rounded-full text-white bg-gray-800 hover:bg-gray-900 focus:bg-black bg-opacity-50 hover:bg-opacity-60 focus:bg-opacity-70 backdrop-filter backdrop-blur-lg p-1 ml-auto transition-all"
      >
        <font-awesome-icon icon="fa-solid fa-xmark" class="w-4.5 h-4.5" />
      </button>
      <!-- ALERTS-->
      <TransitionGroup
        :name="displayedNewAlerts.length > 1 ? 'list' : 'singleAlert'" tag="ul"
        class="w-full sm:w-auto relative transition-all duration-500"
        :class="moveDownAlerts && 'sm:transform sm:translate-y-9'"
      >
        <CornerAlert
          v-for="(alert, idx) in displayedNewAlerts"
          :key="alert.id"
          :alert="alert"
          :idx="idx"
        />
      </TransitionGroup>
      <!-- SHOW MORE BUTTON -->
      <router-link
        v-if="alerts.length > 3 && displayedNewAlerts.length > 0 && doneWaterfalling && screen.sm"
        to="/Alerts"
        class="fadein flex items-center fadein pointer-events-auto cursor-pointer rounded-lg text-white font-semibold bg-gray-800 hover:bg-gray-900 focus:bg-black bg-opacity-50 hover:bg-opacity-60 focus:bg-opacity-70 backdrop-filter backdrop-blur-lg pl-1 pr-3 mt-4 mx-auto transition-all"
        :class="moveDownAlerts && 'transform translate-y-9'"
      >
        + {{ alerts.length - 3 }} more
      </router-link>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"
import CornerAlert from "./CornerAlert.vue"

export default {
  name: "AlertsCorner",
  components: {
    CornerAlert,
  },
  data() {
    return {
      displayedNewAlerts: [],
      doneWaterfalling: false,
      moveDownAlerts: false
    }
  },
  computed: {
    ...mapState(["screen"]),
    ...mapGetters([
      "getNewAlertsFromRefresh",
      "newAlertsArr"
    ]),
    alerts() {
      return this.newAlertsArr
    },
    isSmallestScreen() {
      return !this.screen.sm
    }
  },
  watch: {
    newAlertsArr: {
      handler(val, oldVal) {
        // if getting new alerts, insert them one by one
        if (val.length > oldVal.length) {
          this.waterfallAlerts()
        }
        // else if removing alerts from "refreshed" pile, update array directly
        else {
          for (let i = 0; i < this.displayedNewAlerts.length; i++) {
            const idToMatch = this.displayedNewAlerts[i].id
            if (!this.getNewAlertsFromRefresh[idToMatch]) this.displayedNewAlerts.splice(i, 1)
            if (this.displayedNewAlerts.length === 1) this.moveDownAlerts = false
          }
        }
      },
      deep: true
    },
    isSmallestScreen(val, oldVal) {
      if (val !== oldVal) this.waterfallAlerts()
    }
  },
  methods: {
    ...mapMutations(["moveAlertToInitialBatch"]),
    waterfallAlerts() {
      this.doneWaterfalling = false
      this.displayedNewAlerts = []
      // only show notification counter on small screens
      if (!this.screen.sm && this.alerts.length > 1) {
        this.displayedNewAlerts = [{
          isAggregate: true,
          count: this.alerts.length,
          id: "alertAggregate"
        }]
      }
      else {
        // show latest 3 alerts in reverse order (newest first)
        const newest3 = this.alerts.slice(0, 3).reverse()
        // allow small interval for alerts to pop in
        for (let i = 0; i < Math.min(3, newest3.length); i++) {
          setTimeout(() => {
            this.displayedNewAlerts.push(newest3.pop())
            if (i === 1) this.moveDownAlerts = true
            if (i === 2) setTimeout(() => this.doneWaterfalling = true, 150)
          }, 500 * i)
        }
      }
    },
    closeAllAlerts() {
      for (let alert of this.alerts) {
        this.moveAlertToInitialBatch(alert)
        this.displayedNewAlerts = []
      }
    }
  },
}
</script>

<style>
.alertsCorner {
  z-index: 51;
}
@media screen and (min-width: 640px) {
  .alertsCorner {
    z-index: 30;
  }
}

.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active,
.singleAlert-enter-active,
.singleAlert-leave-active {
  transition: all 0.5s ease;
}
.list-enter,
.list-leave-to,
.singleAlert-enter,
.singleAlert-leave-to {
  transform: translate(0, -120px);
}

@media screen and (min-width: 640px) {
  .list-enter,
  .list-leave-to,
  .singleAlert-enter,
  .singleAlert-leave-to {
    opacity: 0;
    transform: translate(30px, 0);
  }
  /* ensure leaving items are taken out of layout flow so that moving
    animations can be calculated correctly. */
   /* this is why we need both "list" and "singleAlert"
     we do not want this to apply when there is only one alert left
    (causes weird flicker as last alert is closed) */
  .list-leave-active {
    position: absolute;
  }
}


</style>